var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",attrs:{"title":"The title","src":("https://app.livecasts.eu/embed-full/" + _vm.streamId),"frameborder":"0","allow":"autoplay; fullscreen; picture-in-picture","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }